import Vue from 'vue';
import Dropzone from 'dropzone';

Vue.component('file-upload-component', {
    props: ['action', 'token', 'btnString', 'upload-limit'],

    data() {
        return {
            filename: null,
            errorMessage: null
        }
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        Dropzone.autoDiscover = false;

        const myDropzone = new Dropzone(this.$refs.fileUpload, {
            maxFilesize: this.uploadLimit,
            url: this.action,
            addRemoveLinks: true,
            dictDefaultMessage: this.btnString,
            maxFiles: 1,
            acceptedFiles: '.jpg,.png,.jpeg',
            params: {
                'CRAFT_CSRF_TOKEN': this.token
            }
        });

        myDropzone.on('addedfile', () => {
            this.errorMessage = null;
        });

        myDropzone.on('success', (file, response) => {
            const data = JSON.parse(response);
            if (data.filename) {
                this.$refs.assetId.value = data.filename;
                this.filename = file.upload.filename;
                this.$emit('uploaded', data.filename);
            }
        });

        myDropzone.on('error', (file, response) => {
            myDropzone.removeFile(file);
            this.errorMessage = response;
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

    }
});
